"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var index_1 = require("../../index");
var Item_1 = __importDefault(require("./Item"));
var NumberCardComponent = function (props) {
    var _a = props.cardList, cardList = _a === void 0 ? [] : _a, _b = props.themeType, themeType = _b === void 0 ? '' : _b, _c = props.fontColor, fontColor = _c === void 0 ? '' : _c;
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var prefixClassName = "".concat(classPrefix, "-number-card");
    return cardList.length > 0 ? (react_1.default.createElement("section", { className: "".concat(prefixClassName) },
        react_1.default.createElement("div", { className: "".concat(prefixClassName, "__wrap") }, cardList.map(function (item, index) { return (react_1.default.createElement(Item_1.default, __assign({}, item, { key: index, length: cardList.length, themeType: themeType, fontColor: fontColor }))); })))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
function NumberCard(props) {
    var _a = props.cardList, cardList = _a === void 0 ? [] : _a, _b = props.flexTitle, flexTitle = _b === void 0 ? '' : _b, _c = props.desc, desc = _c === void 0 ? '' : _c, mergeComponentStatus = props.mergeComponentStatus, _d = props.flexSmallTitle, flexSmallTitle = _d === void 0 ? '' : _d, _e = props.className, className = _e === void 0 ? '' : _e, style = props.style, paddingTopNum = props.paddingTopNum, paddingBottomNum = props.paddingBottomNum, themeType = props.themeType, fontColor = props.fontColor;
    return (react_1.default.createElement(index_1.CommonContainer, { style: style, className: "".concat(className), flexTitle: flexTitle, paddingTopNum: paddingTopNum, paddingBottomNum: paddingBottomNum },
        (flexTitle || desc || flexSmallTitle) && (react_1.default.createElement(index_1.FlexTitle, { flexTitle: flexTitle, desc: desc, mergeComponentStatus: mergeComponentStatus, flexSmallTitle: flexSmallTitle })),
        react_1.default.createElement(NumberCardComponent, { cardList: cardList, themeType: themeType, fontColor: fontColor })));
}
exports.default = NumberCard;
//# sourceMappingURL=NumberCard.js.map